import { npcLabel, patientLabel } from '~lib/common/utils/labels';
import { activeNpcs } from '~lib/common/utils/npc';

function getAvailableScopes(caseConf) {
  const npcs = activeNpcs(caseConf);
  return [
    {
        id: 'CASE',
        label: 'Scenario'
    },
    {
        id: 'PATIENT',
        label: patientLabel(caseConf)
    },
  ].concat(npcs.map(npc => ({
    id: npc.key,
    label: npcLabel(npc)
  })));
}

export default getAvailableScopes;